import {
  computeOnboardingEligibility,
  hasCompletedOnboardingAtom,
  type OnboardingEligibility,
} from '@heidi/growth/data';
import { useQuerySelfOnboardingTeams } from '@heidi/workspace/data';

import { useCombinedQueriesTeamGeneralInfo, useQueryUser } from '@heidi/workspace/data';
import { useAtomValue } from 'jotai';

/**
 * Binds the app's user, team and same-tab onboarding state to the headless
 * eligibility rule, so a page asks one question rather than restating the
 * self-onboarding modal's checks.
 */
export function useOnboardingEligibility(): OnboardingEligibility {
  const { data: user } = useQueryUser();
  const hasCompletedOnboarding = useAtomValue(hasCompletedOnboardingAtom);
  const { hasTeam, isJoinedTeamsPending } = useCombinedQueriesTeamGeneralInfo();
  const { data: joinableTeamsData, isPending: isJoinableTeamsPending } =
    useQuerySelfOnboardingTeams();

  return computeOnboardingEligibility({
    user,
    hasCompletedOnboarding,
    hasTeam: !!hasTeam,
    isJoinedTeamsPending: !!isJoinedTeamsPending,
    joinableTeams: joinableTeamsData?.data.joinable_teams,
    isJoinableTeamsPending: !!isJoinableTeamsPending,
  });
}
